module.exports = global["surveylab_datetime_datepicker"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./datepicker.ts");